var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tags)?_c('div',{staticClass:"tags mt-3"},_vm._l((_vm.tags),function(tag){return _c('span',{key:'tag_' + tag.term_id,staticClass:"tag"},[_vm._v(" #"+_vm._s(_vm._f("convertEsperluette")(tag.name))+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }